// 中英文
export function chineseEnglish_regfun(rule, value, callback){
  if (value) {
    let reg = /^[\u4e00-\u9fa5A-Za-z]*$/;
    if (!reg.test(value)) {
      let strText = "";
      if(rule.field === "contacter"){
        strText = "联系人";
      }
      callback(new Error(`${strText}填写格式只可为中英文`));
    } else {
      callback();
    }
  } else {
    callback();
  }
};
// 数字---正整数
export function numberInt_regfun(rule, value, callback){
  if (value) {
    let reg = /^[1-9][0-9]*$/;
    if (!reg.test(value)) {
      if (rule.field === "afterOverdue" || rule.field === "loanPeriodExpect") {
        if (Number(value) === 0) {
          callback();
        } else {
          callback(new Error("数值必须为正整数"));
        }
      } else {
        callback(new Error("数值必须为正整数，不可填写0天"));
      }
    } else {
      if(rule.field === "minLoanTerm"){
        if(Number(value) < 8){
          callback(new Error("融资最短期限不可小于8天"));
        }else{
          callback();
        }
      }else{
        callback();
      }
    }
  } else {
    callback();
  }
};
// 利率---保留两位小数
export function rateFloat_regfun(rule, value, callback){
  if (value) {
    if(value == "100" || value == "100.0" || value == "100.00"){
      callback();
    }else{
      let reg = /(^[1-9]([0-9])?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/;
      if (!reg.test(value)) {
        let strText = "";
        if(rule.field === "financingRatio"){
          strText = "融资比例";
        }else if(rule.field === "poundage"){
          strText = "手续费率";
        }else if(rule.field === "overdueInterestRatio"){
          strText = "逾期利率";
        }else{
          strText = "利率";
        }
        callback(new Error(`${strText}最多可填100，否则只可填2位数字值,最多可带2位小数点`));
      } else {
        callback();
      }
    }
  } else {
    callback();
  }
};
// 金额---保留两位小数
export function numberFloat_regfun(rule, value, callback){
  if (value) {
    value = value.replace(/,/gi, ''); // 去除金额千分位‘,’
    let strText = "";
    let reg;
    if(rule.field === "creditAmount"){
      strText = "产品总额度最多为15位，可带2位小数点";
      reg = /(^[1-9]([0-9]{1,14})?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/;
    }else if(rule.field === "minCreditAmountATime" || rule.field === "maxCreditAmountATime"){
      strText = "融资金额最多为15位，可带2位小数点";
      reg = /(^[1-9]([0-9]{1,14})?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/;
    }else{
      strText = "金额最多可带2位小数点";
      reg = /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/;
    }
    if (!reg.test(value)) {
      callback(new Error(strText));
    } else {
      // if(rule.field === "minCreditAmountATime"){
      //   if(Number(value) < 100){
      //     callback(new Error("最低融资金额不可小于100"));
      //   }else{
      //     callback();
      //   }
      // }else{
        callback();
      // }
    }
  } else {
    callback();
  }
};
// 手机号码
export function iphone_regfun(rule, value, callback){
  if (value) {
    let reg = /^1\d{10}$/;
    if (!reg.test(value)) {
      let strText = "";
      if(rule.field === "contactNumber"){
        strText = "联系电话";
      }else{
        strText = "手机号码";
      }
      callback(new Error(`${strText}格式错误`));
    } else {
      callback();
    }
  } else {
    callback();
  }
};
// 手机号码
export function regPhoneRequire(rule, value, callback){
  if (value) {
    let reg = /^1\d{10}$/;
    if (!reg.test(value)) {
      return callback(new Error("请输入正确的手机号码"));
    } else {
      callback();
    }
  } else {
    return callback(new Error("请输入手机号"));
  }
};
// 电话号码 兼容手机和固话
export function regTeleMobliePhone(rule, value, callback){
  if (value) {
    let reg = /^(0\d{2,3}(-|\s?)[1-9]\d{6,7})$|^(1\d{10})$/;
    if (!reg.test(value)) {
      return callback(new Error("请输入正确的电话号码(手机或固定电话)"));
    } else {
      callback();
    }
  } else {
    return callback(new Error("请输入电话号码"));
  }
};
// 不含空格、制表符、换页符的字符串
export function regNoSpace(rule, value, callback){
  if (value) {
    let reg = /\s+/;
    if (reg.test(value)) {
      return callback(new Error("不允许有空格"));
    } else {
      callback();
    }
  } else {
    return callback(new Error("请输入"));
  }
};
// 邮箱校验
export function regEmail(rule, value, callback){
  if (value) {
    let reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
    if (!reg.test(value)) {
      return callback(new Error("请输入正确的邮箱"));
    } else {
      callback();
    }
  } else {
    return callback(new Error("请输入邮箱"));
  }
};

export function regZipcode(rule, value, callback){
  if (value) {
    let reg = /^[1-9]\\d{5}$/;
    if(!reg.test(value)){
      return callback(new Error("请输入正确邮编"));
    }else{
      callback();
    }
  }else{
    return callback(new Error("请输入邮编"));
  }
};